import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";

import Typography from "components/basic/typography";

import { DateField, TimeField } from "../../../../../setAvailability/pickers";
import { SectionLabel } from "../Field";

interface DateTimeSectionProps {
  date: string;
  onDateChange: (value: string) => void;
  allDay: boolean;
  onAllDayChange: (value: boolean) => void;
  from: string;
  onFromChange: (value: string) => void;
  to: string;
  onToChange: (value: string) => void;
  timeInvalid: boolean;
}

const DateTimeSection: React.FC<DateTimeSectionProps> = ({
  date,
  onDateChange,
  allDay,
  onAllDayChange,
  from,
  onFromChange,
  to,
  onToChange,
  timeInvalid,
}) => {
  const { t } = useTranslation("calendar");

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="flex-end">
        <Box sx={{ flex: 1 }}>
          <SectionLabel>{t("booking.date")}</SectionLabel>
          <Box sx={{ mt: 0.5 }}>
            <DateField value={date} onChange={onDateChange} />
          </Box>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="warning"
              checked={allDay}
              onChange={(e) => onAllDayChange(e.target.checked)}
            />
          }
          label={t("booking.all_day")}
        />
      </Stack>
      {!allDay && (
        <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
          <Box>
            <SectionLabel>{t("booking.from")}</SectionLabel>
            <Box sx={{ mt: 0.5 }}>
              <TimeField value={from} onChange={onFromChange} />
            </Box>
          </Box>
          <Box>
            <SectionLabel>{t("booking.to")}</SectionLabel>
            <Box sx={{ mt: 0.5 }}>
              <TimeField value={to} onChange={onToChange} />
            </Box>
          </Box>
        </Stack>
      )}
      {timeInvalid && (
        <Typography
          variant="caption"
          color="error"
          style={{ display: "block", marginTop: 4 }}
        >
          {t("booking.end_after_start")}
        </Typography>
      )}
    </Box>
  );
};

export default DateTimeSection;
